import './new-employment-status.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateEmploymentStatus } from "@core/query/employment-status.query";
import { EmploymentStatusFormRule, EmploymentStatusFormSchema } from "@core/form/form.rule";
import { employmentStatusFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormEmploymentStatus from "../form-employment-status/form-employment-status";

export function NewEmploymentStatus() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateEmploymentStatus } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New EmploymentStatus is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addEmploymentStatus, isLoading: isCreating } =
    useQyCreateEmploymentStatus(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<EmploymentStatusFormSchema>({
    defaultValues: employmentStatusFormDefault,
    resolver: zodResolver(EmploymentStatusFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: EmploymentStatusFormSchema) => {
    const formData = mapCreateEmploymentStatus(form);
    addEmploymentStatus(formData);
  };
  const handleValidateError = (err: FieldErrors<EmploymentStatusFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="EmploymentStatus" className="employment-status">
      <HeaderContent
        title="New Employment Status"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormEmploymentStatus />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewEmploymentStatus;